<template>
	<main class="mb-6 md:mb-12">
		<vx-card>
			<header class="flex justify-between items-center mb-4">
				<h4 class="mr-4"><strong>Top Up & Tagihan</strong></h4>
				<router-link to="/top-up-tagihan">
					Lihat Semua
				</router-link>
			</header>
			<section class="vx-row">
				<div class="vx-col w-full lg:w-2/3 mb-4 lg:mb-0">
					<section class="w-full px-4 py-4" style="border: 1px solid #ccc;border-radius: 10px;">
						<ul class="flex md:hidden items-center justify-between mb-4 pb-2">
							<li class="px-4 mb-topup-product selected-topup" id="mb-topup-product-0">
								<a href="javascript:void(0)" @click.prevent="setMbCatProduct('FormPulsa', 0)">
									<span>Pulsa</span>
								</a>
							</li>
							<li class="px-4 mb-topup-product" id="mb-topup-product-1">
								<a href="javascript:void(0)" @click="setMbCatProduct('FormPaketData', 1)">
									<span>Paket Data</span>
								</a>
							</li>
							<li style="border-left: 1px solid #ccc;" class="px-4">
								<span>
									<feather-icon icon="MoreVerticalIcon"></feather-icon>
								</span>
							</li>
						</ul>
						<ul class="hidden md:flex items-center justify-between md:w-full mb-4 pb-2" style="border-bottom: 1px solid #ccc;">
							<li class="px-4 topup-product selected-topup" id="topup-product-0">
								<a href="javascript:void(0)" @click.prevent="setCatProduct('FormPulsa', 0)">
									<span>Pulsa</span>
								</a>
							</li>
							<li class="px-4 topup-product" id="topup-product-1">
								<a href="javascript:void(0)" @click="setCatProduct('FormPaketData', 1)">
									<span>Paket Data</span>
								</a>
							</li>
							<li class="px-4 topup-product" id="topup-product-2">
								<a href="javascript:void(0)" @click="setCatProduct('FormPLN', 2)">
									<span>Listrik PLN</span>
								</a>
							</li>
							<li class="px-4 topup-product">
								<span>Flight</span>
							</li>
							<li style="border-left: 1px solid #ccc;" class="pl-1">
								<span>
									<feather-icon icon="MoreVerticalIcon"></feather-icon>
								</span>
							</li>
						</ul>
						<component :is="topupComponent"></component>
					</section>	
				</div>
				<div class="vx-col w-full lg:w-1/3">
					<div class="vx-row items-center">
						<div class="vx-col w-1/3 lg:w-1/2 xl:w-1/3">
							<router-link to="/zx-tiket">
								<img v-lazy="`/assets/images/sos/zx-tiket.svg`" alt="" class="responsive" />
							</router-link>
						</div>
						<div class="vx-col w-1/3 lg:w-1/2 xl:w-1/3">
							<router-link to="/zx-food">
								<img v-lazy="`/assets/images/sos/zx-food.svg`" alt="" class="responsive" />
							</router-link>
						</div>
						<div class="vx-col w-1/3 lg:w-1/2 xl:w-1/3 md:mt-6 xl:mt-0">
							<router-link to="/zx-transport">
								<img v-lazy="`/assets/images/sos/zx-transport.svg`" alt="" class="responsive" />
							</router-link>
						</div>
					</div>
				</div>
			</section>
		</vx-card>
	</main>
</template>
<style>
	.selected-topup {
		border-bottom: 2px solid green;
	}
	.selected-topup a {
		font-weight: bold;
	}
</style>
<script>
export default {
	components: {
		FormPulsa: () => import('@/views/home/ppob/components/FormPulsa.vue'),
		FormPaketData: () => import('@/views/home/ppob/components/FormPaketData.vue'),
		FormPLN: () => import('@/views/home/ppob/components/FormPLN.vue')
	},
	data: () => ({
		topupComponent: 'FormPulsa',
		categoryPpob: 'pulsa'
	}),
	methods: {
		setMbCatProduct(componentName, i) {
			// toggle active class
        	document.getElementsByClassName('mb-topup-product').forEach(item => {
		    	item.setAttribute('class', 'mb-topup-product px-4')
		    })
			document.getElementById(`mb-topup-product-${i}`).setAttribute('class', 'mb-topup-product px-4 selected-topup')
			this.topupComponent = componentName
		},
		setCatProduct(componentName, i) {
			// toggle active class
        	document.getElementsByClassName('topup-product').forEach(item => {
		    	item.setAttribute('class', 'topup-product px-4')
		    })
			document.getElementById(`topup-product-${i}`).setAttribute('class', 'topup-product px-4 selected-topup')
			this.topupComponent = componentName
		}
	}
}
</script>